<template>
  <div id="WhatsAppComponent">
    <div class="mb-4">
      <h4>Whatsapp</h4>
    </div>
    <div class="row text-left mb-3">
      <div class="col-4 mb-3">
        <span class="subtext">
          <small>DDI</small>
        </span>
        <DDISelect :cId="newIdd" @getCountry="getCountry($event)" />
      </div>

      <div class="col-8 mb-3">
        <span class="subtext">
          <small>Telefone (DDD + Número)</small>
        </span>
        <the-mask
          v-if="newIdd == 30"
          type="tel"
          class="form-control hide-placeholder"
          :mask="['(##)####-####', '(##)#####-####']"
          placeholder="DDD + número"
          v-model="newNumber"
          @blur.native="verifyNumber"
        />
        <the-mask
          v-else
          :mask="'############'"
          type="tel"
          class="form-control hide-placeholder"
          placeholder="DDD + número"
          v-model="newNumber"
        />
        <p v-if="errorAlert" class="error_alert">
          <small>Número de telefone inválido.</small>
        </p>
      </div>
    </div>

    <span class="subtext">
      <small>Tipo de botão</small>
    </span>
    <b-form-group>
      <b-form-radio-group v-model="messageSelected">
        <b-form-radio
          class="whatsapp-options pb-0"
          v-for="(option, index) in whatsOptions"
          name="whatsOption"
          :key="index"
          :value="option.value"
        >
          <span class="pointer">{{ option.label }}</span>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <template v-if="messageSelected == 6">
      <div class="row m-0 menu-component">
        <div class="col-12 pl-0 mb-2">
          <label for="title-whatsapp">Texto do botão</label>
          <input
            type="text"
            name="whatsapp"
            id="whatsapp"
            class="form-control"
            placeholder="Digite o título do botão"
            v-model="customText"
          />
        </div>
        <div class="col-12 pl-0">
          <label for="message-whatsapp">Texto da mensagem</label>
          <input
            type="text"
            name="message-whatsapp"
            id="message-whatsapp"
            class="form-control"
            placeholder="Digite a mensagem padrão do chat"
            v-model="customMessage"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import DDISelect from "./Country";
export default {
  data() {
    return {
      errorAlert: false,
      messageSelected: 0,
      newIdd: "",
      newNumber: "",
      newContactPhone: "",
      ROOT_API: null,
      customText: "",
      customMessage: "",
      whatsappNumber:"",
      whatsappIndex: "",
      contactPhone:"",
      whatsOptions: [
        {
          label: "Desativado",
          text: "Desativado",
          value: 0,
          message: "",
        },
        {
          label: "Agendar",
          text: "Agendar",
          value: 1,
          message: "Olá, qual dia e horario quer agendar?",
        },
        {
          label: "Fazer Pedido",
          text: "Fazer Pedido",
          value: 2,
          message: "Olá, qual o seu pedido?",
        },
        {
          label: "Encomendar",
          text: "Encomendar",
          value: 3,
          message: "Olá, faça sua encomenda.",
        },
        {
          label: "Chama no Whats",
          text: "Chama no Whats",
          value: 4,
          message: "Olá, como posso ajudar?",
        },
        {
          label: "Pedir Orçamento",
          text: "Pedir Orçamento",
          value: 5,
          message: "Olá, vamos fazer seu orçamento?",
        },
      ],
    };
  },
  components: {
    DDISelect,
  },
  props: {
    siteId: {
      type: Number,
    },
    saveData: {
      type: Boolean,
    },
    whatsappIdd: {
      default: 30,
    },
  },
  created() {
    if (!this.whatsappIdd) {
      this.newIdd = this.$store.state.application.default_idd;
    } else {
      this.newIdd = this.whatsappIdd;
    }
    this.updateData();
  },
  watch: {
    messageSelected() {
      if (this.newIdd === 30) {
        this.verifyNumber();
      }
    },
    saveData() {
      if (this.saveData == true) {
        this.submitSave();
      }
    },
    customText() {
      this.whatsOptions[6].text = this.customText;
    },
    customMessage() {
      this.whatsOptions[6].message = this.customMessage;
    },
  },
  methods: {
    getCountry(event) {
      this.newIdd = event;
    },
    verifyNumber() {
      if (this.messageSelected != 0) {
        const minMobileBrazilNumberLength = 10;
        if (this.newNumber.length >= minMobileBrazilNumberLength) {
          this.errorAlert = false;
        } else {
          this.errorAlert = true;
        }
      } else {
        this.errorAlert = false;
      }
    },
    updateData() {
      let token = this.$session.get("jwt");
      axios({
        method: "get",
        url: `${process.env.ROOT_API}/api/site/${this.siteId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((response) => {
        this.whatsappIndex = response.data.whatsappIndex;
        this.messageSelected = this.whatsappIndex;
        this.whatsappNumber = response.data.whatsappNumber;
        this.newNumber = this.whatsappNumber;
        this.contactPhone = response.data.contactPhone;
        var item = {
          label: "Personalizado",
          text: "Chama no Whats",
          value: 6,
          message: "Olá, como posso ajudar?",
        };

        if (response.data.whatsappIndex == 6) {
          item = {
            label: "Personalizado",
            text: response.data.whatsappButton,
            value: 6,
            message: response.data.whatsappMessage,
          };
          this.customText = response.data.whatsappButton;
          this.customMessage = response.data.whatsappMessage;
        }

        this.whatsOptions.push(item);
      });
    },
    submitSave() {
      let indexMessage = this.messageSelected;
      let formData = new FormData();
      let token = this.$session.get("jwt");
      formData.append("text", this.whatsOptions[indexMessage].text);
      formData.append("value", this.whatsOptions[indexMessage].value);
      formData.append("message", this.whatsOptions[indexMessage].message);
      formData.append("whatsappIdd", this.newIdd);
      formData.append("whatsappNumber", this.newNumber);
      axios({
        method: "post",
        url: `${process.env.ROOT_API}api/site/${this.siteId}/whatsapp/update`,
        data: formData,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data.status == 1) {
            this.$emit("updateMenuOption");
          }
        })
        .catch((response) => {
          //handle error
          console.log("Erro ao salvar");
          this.$emit("updateMenuOption");
        });
    },
  },
};
</script>

<style scoped>
.whatsapp-options {
  display: block;
  border-top: none !important;
  border-bottom: none !important;
}
.custom-control-input:focus {
  outline-offset: none !important;
}
.error_alert {
  color: #d61a1a;
}
.form-control {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/WhatsAppComponent.vue